import React, { useState } from "react";
import data from "./datastructure"; // your MCCB dataset

export default function MCCBSelector() {
  const [component, setComponent] = useState("");
  const [make, setMake] = useState("");
  const [rating, setRating] = useState("");
  const [breakingCapacity, setBreakingCapacity] = useState("");
  const [poles, setPoles] = useState("");
  const [finalItem, setFinalItem] = useState(null);

  // Get unique values for dropdowns based on selection
  const components = [...new Set(data.map(d => d.component))];

  const makes = component
    ? [...new Set(data.filter(d => d.component === component).map(d => d.make))]
    : [];

  const ratings = make
    ? [...new Set(data.filter(d => d.component === component && d.make === make).map(d => d.overload_release_range || d.rating))]
    : [];

  const breakingCapacities = rating
    ? [...new Set(data.filter(d =>
        d.component === component &&
        d.make === make &&
        (d.overload_release_range === rating || d.rating === rating)
      ).map(d => d.breaking_capacity))]
    : [];

  const polesOptions = breakingCapacity
    ? [...new Set(data.filter(d =>
        d.component === component &&
        d.make === make &&
        (d.overload_release_range === rating || d.rating === rating) &&
        d.breaking_capacity === breakingCapacity
      ).map(d => d.poles))]
    : [];

  const handleFinalSelection = (pole) => {
    setPoles(pole);
    const item = data.find(d =>
      d.component === component &&
      d.make === make &&
      (d.overload_release_range === rating || d.rating === rating) &&
      d.breaking_capacity === breakingCapacity &&
      d.poles === pole
    );
    setFinalItem(item);
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow-lg rounded-2xl space-y-4">
      <h1 className="text-xl font-bold text-gray-800">MCCB Price Finder</h1>

      {/* Component */}
      <div>
        <label className="block font-medium">Component</label>
        <select value={component} onChange={e => {setComponent(e.target.value); setMake(""); setRating(""); setBreakingCapacity(""); setPoles(""); setFinalItem(null)}} className="w-full border p-2 rounded">
          <option value="">Select Component</option>
          {components.map((c, i) => <option key={i} value={c}>{c}</option>)}
        </select>
      </div>

      {/* Make */}
      {makes.length > 0 && (
        <div>
          <label className="block font-medium">Make</label>
          <select value={make} onChange={e => {setMake(e.target.value); setRating(""); setBreakingCapacity(""); setPoles(""); setFinalItem(null)}} className="w-full border p-2 rounded">
            <option value="">Select Make</option>
            {makes.map((m, i) => <option key={i} value={m}>{m}</option>)}
          </select>
        </div>
      )}

      {/* Rating */}
      {ratings.length > 0 && (
        <div>
          <label className="block font-medium">Rating</label>
          <select value={rating} onChange={e => {setRating(e.target.value); setBreakingCapacity(""); setPoles(""); setFinalItem(null)}} className="w-full border p-2 rounded">
            <option value="">Select Rating</option>
            {ratings.map((r, i) => <option key={i} value={r}>{r}</option>)}
          </select>
        </div>
      )}

      {/* Breaking Capacity */}
      {breakingCapacities.length > 0 && (
        <div>
          <label className="block font-medium">Breaking Capacity</label>
          <select value={breakingCapacity} onChange={e => {setBreakingCapacity(e.target.value); setPoles(""); setFinalItem(null)}} className="w-full border p-2 rounded">
            <option value="">Select Breaking Capacity</option>
            {breakingCapacities.map((b, i) => <option key={i} value={b}>{b}</option>)}
          </select>
        </div>
      )}

      {/* Poles */}
      {polesOptions.length > 0 && (
        <div>
          <label className="block font-medium">Poles</label>
          <select value={poles} onChange={e => handleFinalSelection(e.target.value)} className="w-full border p-2 rounded">
            <option value="">Select Poles</option>
            {polesOptions.map((p, i) => <option key={i} value={p}>{p}</option>)}
          </select>
        </div>
      )}

      {/* Final Result */}
      {finalItem && (
        <div className="mt-4 p-4 border rounded bg-gray-50">
          <h2 className="font-bold text-lg text-green-700">Final Selection</h2>
          <p><strong>Catalogue No:</strong> {finalItem.catalogue_number}</p>
          <p><strong>Price:</strong> ₹{finalItem.price}</p>
        </div>
      )}
    </div>
  );
}
